export class CustomerCard {
    barcode: string | ArrayBuffer;
    barcodeData: string;
    providerName: string;
}
